export default __webpack_public_path__ + "static/media/FAQ1.c2ef74dd.jpg";